import styled from "styled-components";

import Colors from "../../constants/color";

export const Container = styled.div<{
  isExpanded?: boolean;
  isActive?: boolean;
}>`
  display: flex;
  margin-left: ${(props) => (props.isExpanded ? "8px" : "8px")};
  margin-right: ${(props) => (props.isExpanded ? "8px" : "8px")};
  cursor: pointer;
  height: 48px;
  justify-content: ${(props) => (props.isExpanded ? "flex-start" : "center")};
  align-items: center;
  width: ${(props) => (props.isExpanded ? "calc(100% - 16px)" : "48px")};
  background-color: ${(props) => {
    if (props.isActive) {
      return props.isExpanded ? "#ffffff" : "#1a3fcc";
    }
    return "transparent";
  }};
  border-radius: 8px;
  transition: background-color 0.2s ease, margin 0.3s ease, width 0.3s ease;
  position: relative;

  :hover {
    background-color: ${(props) => {
      if (props.isActive) {
        return props.isExpanded ? "#ffffff" : "#1a3fcc";
      }
      return "#466fff";
    }};
  }
`;

export const NavItem = styled.ul<{ isExpanded?: boolean; isActive?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => {
    if (props.defaultValue === 0) return "space-between";
    return props.isExpanded ? "flex-start" : "center";
  }};
  align-items: center;
  margin: 0;
  padding: ${(props) => (props.isExpanded ? "0 8px" : "0")};
  height: 48px;
  width: 100%;
  gap: ${(props) => (props.isExpanded ? "8px" : "0")};
  position: relative;
  transition: padding 0.3s ease, gap 0.3s ease;
`;
export const ListItemTextNav = styled.div<{
  isExpanded?: boolean;
  isActive?: boolean;
}>`
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  margin-left: ${(props) => (props.isExpanded ? "16px" : "0")};
  color: ${(props) =>
    props.isActive && props.isExpanded ? "#2d5bff" : "#ffffff"};
  font-family: Inter;
  opacity: ${(props) => (props.isExpanded ? "1" : "0")};
  width: ${(props) => (props.isExpanded ? "auto" : "0")};
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.3s ease;
`;
export const BoxIcon = styled.div<{ isExpanded?: boolean; isActive?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;

  svg,
  img {
    width: ${(props) => (props.isExpanded ? "16px" : "24px")};
    height: ${(props) => (props.isExpanded ? "16px" : "24px")};
    transition: all 0.3s ease;
    color: ${(props) => {
      if (props.isActive && props.isExpanded) return "#2d5bff";
      return "#ffffff";
    }} !important;
    fill: ${(props) => {
      if (props.isActive && props.isExpanded) return "#2d5bff";
      return "#ffffff";
    }} !important;
  }

  svg path {
    fill: ${(props) => {
      if (props.isActive && props.isExpanded) return "#2d5bff";
      return "#ffffff";
    }} !important;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const style = {
  width: "100%",
  textDecorationLine: "none",
};

export const TagNovo = styled.div`
  padding: 5px 10px;
  margin-left: 8px;
  margin-left: 8px;
  background-color: #ed6c0233;
  color: #ed6c02;
  font-size: 0.75rem;
  border-radius: 1rem;
  font-family: "Inter";
`;
